import React, { useCallback, useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  ThumbUpAltOutlinedIcon,
  ThumbDownAltOutlinedIcon,
  Button,
} from "app/material-framework/materialComponents";
import { feedbackService } from "../app/services/nairaService";

export function ChatbotFeedback({ idx, msg, conv_id, feedback, setFeedback }) {
  const [showFeedbackBox, setShowFeedbackBox] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const [dislikeSubmitted, setDislikeSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFeedback = useCallback(
    async (type) => {
      setFeedback((prev) => ({
        ...prev,
        [idx]: { type, comment: type === "like" ? "" : prev[idx]?.comment || "" },
      }));
      if (type === "dislike") {
        setShowFeedbackBox(idx);
        setDislikeSubmitted(false);
      } else {
        setShowFeedbackBox(null);
        setDislikeSubmitted(false);
        await feedbackService(conv_id, msg.question_id, "like");
      }
    },
    [conv_id, idx, msg.question_id, setFeedback],
  );

  const handleSubmitDislike = useCallback(async () => {
      setIsSubmitting(true);
      try {
        setFeedback((prev) => ({
          ...prev,
          [idx]: { type: "dislike", comment: feedbackText.trim() },
        }));
        await feedbackService(conv_id, msg.question_id, "dislike", feedbackText.trim());
        setDislikeSubmitted(true);
        handleCloseFeedbackBox();
      } finally {
        setIsSubmitting(false);
      }
    }, [conv_id, idx, msg.question_id, feedbackText, setFeedback, handleCloseFeedbackBox]);

  const handleCloseFeedbackBox = useCallback(() => {
    setShowFeedbackBox(null);
    setFeedbackText("");
  }, []);

  return (
    <Box sx={{ mt: 0.5 }}>
      <IconButton
        size="small"
        color={feedback[idx]?.type === "like" ? "primary" : "default"}
        onClick={() => handleFeedback("like")}
        aria-label="Like"
      >
        <ThumbUpAltOutlinedIcon />
      </IconButton>
      <IconButton
        size="small"
        color={dislikeSubmitted ? "primary" : "default"}
        onClick={() => handleFeedback("dislike")}
        aria-label="Dislike"
      >
        <ThumbDownAltOutlinedIcon />
      </IconButton>
      {showFeedbackBox === idx && (
        <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 1 }}>
          <TextField
            multiline
            minRows={2}
            maxRows={4}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Please tell us what was wrong..."
            variant="outlined"
            size="small"
            sx={{ width: 260 }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button size="small" onClick={handleCloseFeedbackBox} sx={{ textTransform: "none" }} color="secondary">
              Close
            </Button>
            <Button
              size="small"
              onClick={handleSubmitDislike}
              sx={{ textTransform: "none" }}
              color="primary"
              variant="contained"
              disabled={isSubmitting}
            >
              Submit
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
